import { render, staticRenderFns } from "./Sifcop.vue?vue&type=template&id=f1cd377e&scoped=true"
import script from "./Sifcop.vue?vue&type=script&setup=true&lang=js"
export * from "./Sifcop.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Sifcop.vue?vue&type=style&index=0&id=f1cd377e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cd377e",
  null
  
)

export default component.exports